














import Vue from 'vue'
import PaidLabel from '@/components/PaidLabel/PaidLabel.vue'
import { ResSavedFilter, ReqSavedFilter } from '@/models/users'
import { SAVEDFILTERS__LOAD } from '@/store/actions'
import { mapActions } from 'vuex'
import iconDelete from '@/assets/svg/rounded/delete.svg?inline'
import iconCaretDown from '@/assets/svg/rounded/caret-down.svg?inline'
import { Company } from '@/models/companies'

interface Data {
  hideFilters: boolean
}

interface Props {
  newSavedFiltersValue: ReqSavedFilter
  currentSavedFilters: ResSavedFilter[]
  applyedFilterId: string
}

interface Methods {
  [SAVEDFILTERS__LOAD]: (sectionName: string) => void
  getFilters: () => void
  deleteFilter: (filter: ResSavedFilter) => void
  applySavedFilter: (filter: ResSavedFilter) => void
  isApplyedFilter: (id: string) => boolean
}

interface Computed {
  activeCompany: Company | undefined
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    PaidLabel,
    iconCaretDown,
    iconDelete,
  },
  props: {
    newSavedFiltersValue: {
      required: true,
    },
    currentSavedFilters: {
      required: true,
    },
    applyedFilterId: {
      required: true
    }
  },
  data() {
    return {
      hideFilters: false,
    }
  },
  methods: {
    ...mapActions([SAVEDFILTERS__LOAD]),
    getFilters() {
      if (this.newSavedFiltersValue.section.length) {
        this[SAVEDFILTERS__LOAD](this.newSavedFiltersValue.section)
      }
    },
    applySavedFilter(filter) {
      this.getFilters()
      this.$emit('apply-saved-filter', filter)
    },
    deleteFilter(filter) {
      this.$emit('delete-saved-filter', filter)
    },
    isApplyedFilter(id) {
      return this.applyedFilterId === id 
    }
  },
  computed: {
    activeCompany() {
      return this.$store.getters.getActiveCompany
    },
  },
  mounted() {
    this.getFilters()
  },
  watch: {
    activeCompany() {
      this.getFilters()
    },
  }
})
